var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { alert, request, loadingModal } from "@pagser/common";
import { createSlice } from "@reduxjs/toolkit";
import { setId as setUserId, setStatus as setUserStatus, setSubscribed as setUserSubscribed, setReadLater as setUserReadLater, setSubscribed, } from "./userSlice";
var initialState = {
    loading: true,
    id: "",
    contents: {
        title: "",
        briefDescription: "",
        targets: "",
        body: "",
    },
    photoUrl: "",
    author: {
        id: "",
        photoUrl: "",
        biography: "",
        username: "",
        name: "",
        subscribersCount: 0,
    },
    configurations: {
        anonymously: false,
        comments_disabled: false,
        ratings_disabled: false,
        links_disabled: false,
    },
    date: "",
    ratings: {
        likes: 0,
        dislikes: 0,
    },
    attachFiles: [],
};
export var pageSlice = createSlice({
    name: "page",
    initialState: initialState,
    reducers: {
        setLoading: function (state, action) {
            state.loading = action.payload;
        },
        setId: function (state, action) {
            state.id = action.payload;
        },
        setContents: function (state, action) {
            state.contents = action.payload;
        },
        setPhotoUrl: function (state, action) {
            state.photoUrl = action.payload;
        },
        setAuthor: function (state, action) {
            state.author = action.payload;
        },
        setSubscribersCount: function (state, action) {
            state.author.subscribersCount = action.payload;
        },
        setConfigurations: function (state, action) {
            state.configurations = action.payload;
        },
        setDate: function (state, action) {
            state.date = action.payload;
        },
        setRatings: function (state, action) {
            state.ratings = action.payload;
        },
        setAttachFiles: function (state, action) {
            state.attachFiles = action.payload;
        },
    },
});
export var setLoading = (_a = pageSlice.actions, _a.setLoading), setId = _a.setId, setContents = _a.setContents, setPhotoUrl = _a.setPhotoUrl, setAuthor = _a.setAuthor, setSubscribersCount = _a.setSubscribersCount, setConfigurations = _a.setConfigurations, setDate = _a.setDate, setRatings = _a.setRatings, setAttachFiles = _a.setAttachFiles;
// Fetch the data needed for a public page
export var fetchPublicPage = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, request.get("/public-pages/".concat(window.location.pathname.split("/")[2]), {
                        auth: true,
                    })];
            case 1:
                response = _a.sent();
                dispatch(setLoading(false));
                dispatch(setId(response.page.id));
                dispatch(setContents(response.page.contents));
                dispatch(setPhotoUrl(response.page.photoUrl || ""));
                dispatch(setAuthor({
                    id: response.page.author.id,
                    photoUrl: response.page.author.photoUrl || "",
                    biography: response.page.author.biography,
                    username: response.page.author.username,
                    name: response.page.author.name || response.page.author.username,
                    subscribersCount: response.page.author.subscribersCount,
                }));
                dispatch(setDate(response.page.date));
                dispatch(setRatings({
                    likes: response.page.likes,
                    dislikes: response.page.dislikes,
                }));
                dispatch(setAttachFiles(response.page.attachFiles));
                dispatch(setConfigurations({
                    anonymously: response.page.anonymously,
                    comments_disabled: response.page.comments_disabled,
                    ratings_disabled: response.page.ratings_disabled,
                    links_disabled: response.page.links_disabled,
                }));
                // From the userSlice
                dispatch(setUserId(response.viewer.id || ""));
                dispatch(setUserStatus(response.viewer.status));
                dispatch(setUserSubscribed(response.viewer.subscribed || false));
                dispatch(setUserReadLater(response.viewer.readLater || false));
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                dispatch(setLoading(false));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
// Fetch the data needed for a private page
export var fetchPrivatePage = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, request.get("/".concat(window.location.pathname.split("/")[1], "/").concat(window.location.pathname.split("/")[2]), {
                        auth: true,
                        alert: false,
                    })];
            case 1:
                response = _a.sent();
                dispatch(setLoading(false));
                dispatch(setId(response.page.id));
                dispatch(setContents(response.page.contents));
                dispatch(setConfigurations({
                    anonymously: response.page.anonymously,
                    comments_disabled: response.page.comments_disabled,
                    ratings_disabled: response.page.ratings_disabled,
                    links_disabled: response.page.links_disabled,
                }));
                dispatch(setPhotoUrl(response.page.photoUrl || ""));
                dispatch(setAuthor({
                    id: response.page.author.id,
                    photoUrl: response.page.author.photoUrl || "",
                    biography: response.page.author.biography,
                    username: response.page.author.username,
                    name: response.page.author.name || response.page.author.username,
                    subscribersCount: response.page.author.subscribersCount,
                }));
                dispatch(setDate(response.page.date));
                dispatch(setRatings({
                    likes: response.page.likes,
                    dislikes: response.page.dislikes,
                }));
                dispatch(setAttachFiles(response.page.attachFiles));
                // From the userSlice
                dispatch(setUserId(response.viewer.id || ""));
                dispatch(setUserStatus(response.viewer.status));
                dispatch(setUserSubscribed(response.viewer.subscribed || false));
                dispatch(setUserReadLater(response.viewer.readLater || false));
                return [3 /*break*/, 3];
            case 2:
                e_2 = _a.sent();
                dispatch(setLoading(false));
                if (e_2.status === 404 || e_2.status === 403 || e_2.status === 401) {
                    if (e_2.status !== 404)
                        console.log("Unauthorized access attempt:", e_2);
                    dispatch(setId("0")); // zero indicates not found / not authorized
                }
                else {
                    request.handleError(e_2);
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
// Add a page to the read later list of a user or remove it from there
export var toggleReadLater = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    loadingModal("Loading...");
                    return [4 /*yield*/, request.patch("/read-later/".concat(id), null, {
                            auth: true,
                            alert: false,
                        })];
                case 1:
                    response = _a.sent();
                    loadingModal();
                    if (response.readLater) {
                        alert("Page added to the read later list.", "success");
                    }
                    else {
                        alert("Page removed from the read later list.", "success");
                    }
                    dispatch(setUserReadLater(response.readLater));
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    loadingModal();
                    request.handleError(e_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
// Send a request to server to delete the page photo
export var deletePhoto = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var id, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                id = getState().page.id;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                loadingModal("Removing the photo...");
                return [4 /*yield*/, request.delete("/pages/".concat(id, "/photo"), {
                        auth: true,
                    })];
            case 2:
                _a.sent();
                loadingModal();
                alert("Photo successfully removed from your page.", "success");
                dispatch(setPhotoUrl(""));
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                loadingModal();
                alert("There was a problem removing the photo.", "error");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
// Fetches the attach files of a page
export var fetchAttachFiles = function (message) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var id, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = getState().page.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, request.get("/pages/".concat(id, "/attach-files"), {
                            auth: true,
                        })];
                case 2:
                    response = _a.sent();
                    loadingModal();
                    alert(message, "success");
                    dispatch(setAttachFiles(response.attachFiles));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    loadingModal();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
// Send a request to server to either subscribe to or unsubscribe from the author
export var subscribe = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var authorId, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                authorId = getState().page.author.id;
                return [4 /*yield*/, request.post("/subscription/".concat(authorId), null, {
                        auth: true,
                    })];
            case 1:
                response = _a.sent();
                response.subNum;
                dispatch(setSubscribersCount(response.subNum));
                dispatch(setSubscribed(response.subscribed));
                if (response.subscribed) {
                    alert("Successfully subscribed to the author.", "success");
                }
                else {
                    alert("Successfully unsubscribed from the author.", "success");
                }
                return [2 /*return*/];
        }
    });
}); }; };
export var selectId = function (state) { return state.page.id; };
export var selectContents = function (state) { return state.page.contents; };
export var selectConfigurations = function (state) {
    return state.page.configurations;
};
export var selectLoading = function (state) { return state.page.loading; };
export var selectDate = function (state) { return state.page.date; };
export var selectPhotoUrl = function (state) { return state.page.photoUrl; };
export var selectAttachFiles = function (state) { return state.page.attachFiles; };
export var selectAuthor = function (state) { return state.page.author; };
export var selectRatings = function (state) { return state.page.ratings; };
export default pageSlice.reducer;
